var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListAltCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2698_899",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2698_899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.56224 23.3334C6.01819 23.3334 5.5663 23.1535 5.20658 22.7938C4.84685 22.434 4.66699 21.9857 4.66699 21.4486V6.55144C4.66699 6.01438 4.84685 5.56599 5.20658 5.20627C5.5663 4.84655 6.01469 4.66669 6.55174 4.66669H21.4489C21.986 4.66669 22.4344 4.84655 22.7941 5.20627C23.1538 5.56599 23.3337 6.01438 23.3337 6.55144V15.7366L20.1297 18.9403L17.7628 16.5734L12.9839 21.3232L14.9943 23.3334H6.56224ZM13.058 14.5834H19.3402V13.4167H13.058V14.5834ZM13.058 10.1859H19.3402V9.01923H13.058V10.1859ZM20.1297 24.5L16.9304 21.3232L17.7628 20.4975L20.1297 22.8644L24.8637 18.1306L25.6895 18.9627L20.1297 24.5ZM9.46987 14.8975C9.72459 14.8975 9.9376 14.8113 10.1089 14.6391C10.28 14.4668 10.3656 14.2533 10.3656 13.9986C10.3656 13.7438 10.2794 13.5308 10.1072 13.3595C9.93488 13.1882 9.72138 13.1026 9.46666 13.1026C9.21194 13.1026 8.99892 13.1887 8.82762 13.361C8.65651 13.5333 8.57095 13.7468 8.57095 14.0015C8.57095 14.2562 8.65709 14.4692 8.82937 14.6405C9.00164 14.8118 9.21515 14.8975 9.46987 14.8975ZM9.46987 10.5C9.72459 10.5 9.9376 10.4139 10.1089 10.2416C10.28 10.0693 10.3656 9.85583 10.3656 9.6011C10.3656 9.34638 10.2794 9.13337 10.1072 8.96206C9.93488 8.79076 9.72138 8.7051 9.46666 8.7051C9.21194 8.7051 8.99892 8.79124 8.82762 8.96352C8.65651 9.1358 8.57095 9.3493 8.57095 9.60402C8.57095 9.85874 8.65709 10.0718 8.82937 10.2431C9.00164 10.4144 9.21515 10.5 9.46987 10.5Z",
    fill: "#8FDECC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListAltCheck);
export default __webpack_public_path__ + "static/media/list_alt_check.d045aea0354d9fe4bc5047453b57084a.svg";
export { ForwardRef as ReactComponent };